$(document).ready(function () {
  var checkmark = $(".checkmark");
  var form = $("form.create-customer-form");
  var agree = true;
  var bodySection = $("body");

  form.on("submit", function (e) {
    if (!agree) {
      return false;
    }
  });

  checkmark.on("click", function (e) {
    agree ? (agree = false) : (agree = true);
  });

  $(".menu")
    .mouseenter(function (e) {
      $(this).toggleClass("animated");
    })
    .mouseleave(function () {
      $(this).removeClass("animated");
    });

  window.onscroll = function () {
    var asideY = $(this).scrollTop();
    var navbar = document.getElementById("navbar");
    if (asideY > 400) {
      //Antes era 34
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  };

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    dots: true,
    asNavFor: ".slider-nav"
  });

  $(".slider-nav").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    vertical: true,
    verticalSwiping: true,
    centerPadding: "50%",
    swipeToSlide: true,
    centerMode: true,
    focusOnSelect: true,
    infinite: true,
    arrows: false
  });

  $(".change-display-info").click(function (e) {
    $(this)
      .parent()
      .next("div")
      .toggle();
    var el = $(this);
    if (el.text() == el.data("text-swap")) {
      el.text(el.data("text-original"));
    } else {
      el.data("text-original", el.text());
      el.text(el.data("text-swap"));
    }
  });

  $(".button-mobile-menu").click(function () {
    $(this)
      .parent()
      .next("div")
      .toggle(500);
    var el = $(this);
    if (el.text() == el.data("text-swap")) {
      el.text(el.data("text-original"));
    } else {
      el.data("text-original", el.text());
      el.text(el.data("text-swap"));
    }
  });

  $(".close-modal-product").click(function () {
    document.getElementById("modalSuccess").style.display = "none";
  })

  $(".continue-shopping").click(function () {
    document.getElementById("modalSuccess").style.display = "none";
  })

  // $(".menu-mobile-links").click(function () {
  //   $(this).parent().next("div").toggle(1000);
  //   var el = $(this).next("button");
  //   if (el.text() == el.data("text-swap")) {
  //     el.text(el.data("text-original"));
  //   } else {
  //     el.data("text-original", el.text());
  //     el.text(el.data("text-swap"));
  //   }
  // });

  $(".open-menu-button").click(function () {
    $(this)
      .parent()
      .next()
      .next()
      .next()
      .toggleClass("open-menu");
  });

  $(".menu-close").click(function () {
    $(this)
      .parent()
      .parent()
      .parent()
      .removeClass("open-menu");
  });

  // When the user clicks the button, open the modal
  jQuery("#myBtn").on("click", function (e) {
    document.getElementById("myModal").style.display = "block";
    bodySection.addClass("modal-opened");
  });

  // When the user clicks on <span> (x), close the modal
  jQuery(".close").on("click", function (e) {
    document.getElementById("myModal").style.display = "none";
    bodySection.removeClass("modal-opened");
  });

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == document.getElementById("myModal")) {
      document.getElementById("myModal").style.display = "none";
      bodySection.removeClass("modal-opened");
    }
  };

  $("body").on(
    "click",
    '[name="create_account"], [name="goto_pp"], [name="goto_gc"]',
    function () {
      if ($("#agree").is(":checked")) {
        $(this).submit();
      } else {
        alert(
          "You must agree with the terms and conditions of sales to check out."
        );
        return false;
      }
    }
  );

  var $form = $(".footer-subscribe-form");

  if ($form.length > 0) {
    $('.footer-subscribe-form input[type="submit"]').bind("click", function (
      event
    ) {
      if (event) event.preventDefault();
      // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
      if (true) {
        register($form);
      }
    });
  }

  $(".hero-banner").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 6000,
    nav: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0055/9094/1786/files/left-arrow.png' class='owl-left-arrow-nav' alt=''/>",
      "<img src='https://cdn.shopify.com/s/files/1/0055/9094/1786/files/right-arrow.png' class='owl-left-arrow-nav'/>"
    ]
  });

  $(".responsive-banner").owlCarousel({
    items: 4,
    loop: true,
    nav: true,
    dots: true,
    margin: 30,
    navText: [
      "<img src='//cdn.shopify.com/s/files/1/0055/9094/1786/t/5/assets/leftArrowDesactivate.svg' alt=''>",
      "<img src = '//cdn.shopify.com/s/files/1/0055/9094/1786/t/5/assets/rightArrow.svg' alt =''/>"
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        margin: 10,
        mouseDrag: false
      },
      768: {
        items: 3,
        nav: false,
        margin: 20
      },
      1200: {
        items: 4,
        nav: true,
        margin: 20
      }
    }
  });

  $(".responsive-banner-2").owlCarousel({
    items: 3,
    loop: true,
    nav: false,
    dots: false,
    margin: 40,
    navText: [
      "<img src='//cdn.shopify.com/s/files/1/0055/9094/1786/t/5/assets/leftArrowDesactivate.svg?105207' alt=''>",
      "<img src = '//cdn.shopify.com/s/files/1/0055/9094/1786/t/5/assets/rightArrow.svg?16166' alt =''/>"
    ],
    responsive: {
      0: {
        items: 2,
        nav: false,
        margin: 20,
        mouseDrag: false
      },
      768: {
        items: 3,
        nav: false,
        margin: 30
      },
      1200: {
        items: 3,
        nav: true,
        margin: 30
      }
    }
  });

  $("#search-icon-to-open").click(function () {
    inputSearch = document.getElementById("SearchMobile");
    inputSearch.click();
  });

  $('.variant-offers').on('change', function(){
      setTimeout(function(){ 
        if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
          location.reload();
        }
      }, 1);
  });
});

function register($form) {
  $.ajax({
    type: "GET",
    url: $form.attr("action"),
    data: $form.serialize(),
    cache: false,
    dataType: "jsonp",
    contentType: "application/json; charset=utf-8",
    error: function (xhr, status, errorThrown) {
      console.log("error:" + JSON.stringify(errorThrown));
    },
    success: function (data) {
      var suscribe_input = jQuery(".suscribe-input");
      var suscribe_response = jQuery(".suscribe-response");
      if (data.result == "success") {
        suscribe_response
          .css("display", "block")
          .html("Gracias por suscribirte a nuestros boletines.");
        suscribe_input.val("");
      }
      if (data.result == "error") {
        suscribe_response
          .css("display", "block")
          .html(
            "Ha ocurrido un error al intentar registrarte. Es posible que el correo elctrónico se encuentre registrado o presentamos algún problema interno."
          );
      }
    }
  });


}
